import { Cache } from 'aws-amplify'

// [OFF, OLD, NEW]
const pricingMap = [7, 2, 9]

export default function pricingReference() {
  const pricingVariant = parseInt(Cache.getItem('pricingVariant') || 0, 10)
  const pricingNum = pricingMap[pricingVariant]
  const pricingRef = pricingNum ? `${Math.random().toString().slice(2, 5)}${pricingNum}` : undefined
  return pricingRef
}
